<span
  [ngClass]="ngClass"
  class="ui-rating__value">
    {{ value > 0 ? '+' : '' }}{{ value }}
</span>
